import com from "@/api/common.js"; //工具
import tools from "@/api/tools.js"; //工具
export const loading = {
  data() {
    return {
      loading: false,
    }
  },
  watch: {
    loading(val) {
      try {
        this.$root.$children[0].loading = val;
      } catch (e) {
        console.log("loading写入异常");
      }
    }
  }
}
export const share = {

  methods: {
    openSharePanel(shareData, convert) {
      if (convert) {
        this.$http({
          type: "PUT",
          url: "/bplatTool/transformLongUrl",
          data: {
            url: shareData.link,
          }
        }).then(res => {
          shareData.link = res.data;
          this.$app.openSharePanel(shareData);
        })
      } else {
        this.$app.openSharePanel(shareData);
      }
    },
    // convert是否需要转换短链接
    shareInit(shareData, convert) {
      console.log('com.isApp', com.isApp)
      if (com.isApp) {
        if (convert) {
          this.$http({
            type: "PUT",
            url: "/api/aplatTool/transformLongUrl",
            data: {
              url: encodeURIComponent(shareData.link),
            }
          }).then(res => {
            shareData.link = res.data;
            this.$app.initShare(shareData);
          })
        } else {
          this.$app.initShare(shareData);
        }
      } else {
        this.$weixin.share(shareData);
      }
    }
  }
}
export const common = {
  mixins: [share],
  data() {
    return {
      loading: false,
      wxInfo: {},
      all: {
        POLICY_STATUS: {}
      }, //字典数据
    }
  },
  watch: {
    loading(val) {
      try {
        this.$root.$children[0].loading = val;
      } catch (e) {
        console.log("loading写入异常");
      }
    }
  },
  methods: {
    initShare() {
      if (this.$tools.isWeiXin()) {
        const isKh = this.$route.query.userId;
        if (!isKh) {
          //姜子牙用户
          this.userInfo = JSON.parse(localStorage.jzy_user);
          this.setShareConfig();
          return;
        } else {
          if (!localStorage.jzy_kh) {
            //客户打开
            wxAPI.wxmplogin(
              {
                requestUrl: "/api/user/loginByAuth",
                notCommponentAppid: true
              },
              data => {
                console.log("wxmplogin", data);
                this.userInfo = data.data;
                localStorage.jzy_kh = JSON.stringify(this.userInfo);
                this.setUserinfoAjax(); //微信信息传到后台
              }
            );
          } else {
            this.userInfo = JSON.parse(localStorage.jzy_kh);
            this.setUserinfoAjax(); //微信信息传到后台
          }
        }
      }
    },
    checkLogin() {
      // token不存在跳转登录
      if (!localStorage.jzy_token) {
        tools.outLogin();
        return false;
      }
      this.checkWxAuth();
      return true;
    },
    // 验证微信授权
    checkWxAuth() {
      if (localStorage.jzy_auth) {
        return;
      }
      if (!this.$tools.isWeiXin()) {
        return;
      }
      if (!localStorage.orgId) {
        console.log("orgId不存在")
        this.wxmplogin();
        return
      }
      this.$http({
        type: "GET",
        url: "/api/userBase/checkOpenid",
        hideAlert: true,
        data: {
          orgId: localStorage.orgId,
        }
      }).then(res => {
        if (res.data) {
          localStorage.jzy_openid = res.data;
        } else {
          this.wxmplogin();
        }
      })
    },
    wxmplogin() {
      let appid = "wx50a095f10fed08ba";
      if (this.$config.env == 1) {
        appid = "wxe4ea1755d6ab3c82";
      }
      if (this.$route.query.code) {
        this.$weixin.wxmplogin({
          appid: appid
        });
      } else {
        if (!localStorage.jzy_user) {
          this.$notice.inquiry("接收模板消息需要您的授权", ["去授权", "取消"], () => {
            localStorage.jzy_openid = "";
            this.$weixin.wxmplogin({
              appid: appid
            });
          }, () => {
            localStorage.jzy_auth = "false";
          })
        }

      }
    },
    setUser(data) {
      const user = this.getUser();
      Object.assign(user, data);
      localStorage.jzy_user = JSON.stringify(user);
    },
    getUser() {
      try {
        const user = JSON.parse(localStorage.jzy_user);
        return user;
      } catch (error) {
        return {};
      }
    },
    openFile(url, title, logo, content = "") {
      // if(url.toLowerCase().indexOf(".pdf") != -1){
      //   location.href = "https://bx.wts999.com/m/pdf/viewer.html?file="+url;
      // }else{
      //   location.href = url;
      // }
      if (com.isApp) {
        if (url.toLowerCase().indexOf(".pdf") != -1) {
          var rou = this.$router.resolve({
            path: "/apps/fileView",
            query: {
              src: url,
              logo,
              title,
              shareText: content
            }
          });
          location.href = rou.href;
          // this.$app.readPdf({url});
        } else {
          this.$notice.msg("暂只支持PDF文件预览");
        }
      } else if (tools.ios) {
        location.href = url;
      } else {
        var rou = this.$router.resolve({
          path: "/apps/fileView",
          query: {
            src: url,
            logo,
            title,
            shareText: content
          }
        });
        location.href = rou.href;
      }
    },
    goPage(url, params) {
      this.$router.push({
        path: url,
        query: params
      });
    },
    jumpPage(url, inside, params) {
      if (inside) {
        this.goPage(url, params)
      } else {
        location.href = url;
      }
    },
    goProductDeatil(code, info) {
      if( info && info.url ){
        location.href = info.url
      } else if (info.supportApp == '1') {
        const userId = this.getUser().userId;
        location.href = `/m/product/app/detail?uId=${userId}&c=${code}`
      } else {
        this.$toast(info.tips);
      }

      // if (info && info.status) {
      //   if (info.lastNum > 0) {
      //     const userId = this.getUser().userId;
      //     location.href = `/m/product/app/detail?uId=${userId}&c=${code}`
      //   } else {
      //     this.$notice.msg("您的赠险份数不足");
      //   }
      // } else {
      //   const userId = this.getUser().userId;
      //   location.href = `/m/product/app/detail?uId=${userId}&c=${code}`
      // }
    },
    setAllData(params = {}) {
      return new Promise((resolved, rejected) => {
        if (sessionStorage.jzy_allData) {
          try {
            this.all = JSON.parse(sessionStorage.jzy_allData);
            resolved();
            return;
          } catch (error) {
            rejected();
            console.log("ALL数据解析异常");
          }
        }
        if (com.isApp) {
          this.$app.getSystemReadDic(params, res => {
            if (res) {
              try {
                if (params.type) {
                  this.$set(this.all, params.type, JSON.parse(res))
                } else {
                  this.all = JSON.parse(res);
                }
                resolved();
              } catch (error) {
                rejected();
                console.log("all数据解析异常");
              }
            }
          }, error => {
            rejected();
            console.log("allError", error)
          })
        } else {
          this.$http({
            url: "/api/dic/read/all",
            type: "GET",
          }).then(resData => {
            this.all = resData.data;
            sessionStorage.jzy_allData = JSON.stringify(resData.data);
            resolved();
          });
        }
      })
    },
    //校验密码
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp(
        "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]"
      );

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.msg(
          "密码长度8-16位，包含数字、大写字母、小写字母、符号中的至少3种"
        ); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
  }
}
export const pageTools = {
  data() {
    return {
      requestType: 'POST',
      pageNum: 1,
      pageSize: 10,
      list: [],
      listUrl: "",
      orderType: "",
      listCount: 0,
      listLoading: false,
      finished: false, //是否加载完成
      finishedText: "暂无更多数据",
      timer: {},
      flag: true
    }
  },
  methods: {
    setRequestType(type) {
      this.requestType = type;
    },
    initListAjax(url, flag) {
      this.listUrl = url;
      this.flag = flag
      this.getListHttp();
    },
    // 搜索
    searchAjax(url) {
      if (url) {
        this.listUrl = url;
      }

      // this.finishedText = "";
      this.finished = false;
      this.listLoading = true;
      this.pageNum = 1;
      this.list = [];
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        const params = {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
        this.setListParams(params);
        if (params.pageNum == 1) {
          this.list = [];
        }
        this.listLoading = true;
        if (!this.listUrl) {
          return;
        }

        this.$http({
          type: this.requestType,
          url: this.listUrl,
          data: params
        }).then(resData => {
          if (resData.rows.length == 0) {
          }

          this.listLoading = false;
          ++this.pageNum;

          const list = resData.rows
          this.listCount = resData.total;
          if (this.pageNum > 2) {
            this.list = this.list.concat(list);
          } else {
            this.list = list;
          }

          if (this.list.length < resData.total) {
            this.finished = false;
            this.finishedText = ""
          } else {
            this.finished = true;
            this.finishedText = "暂无更多数据"
          }

          if (this.list.length == 0) {
            this.finished = true;
            this.finishedText = ""
          }
          this.listCallback(resData);
        }).catch(e => {
          this.finished = true;
          this.finishedText = ""
        });
      }, 500)
    },
    // 设置自定义参数
    setListParams(params) { },
    //请求回调
    listCallback() { },
    nextPage() {
      if (this.listUrl) {
        // this.flag = 0;
        this.getListHttp();
      }
    },
    // ajax请求
    getListHttp() {
      const params = {
        pageNo: this.pageNum,
        pageSize: this.pageSize
      }
      this.setListParams(params);
      if (params.pageNum == 1) {
        this.list = [];
      }
      this.listLoading = true;
      if (!this.listUrl) {
        return;
      }

      this.$http({
        type: this.requestType,
        url: this.listUrl,
        data: params
      }).then(resData => {
        if (resData.rows.length == 0) {
        }

        this.listLoading = false;
        ++this.pageNum;

        const list = resData.rows
        this.listCount = resData.total;
        if (this.pageNum > 2) {
          this.list = this.list.concat(list);
        } else {
          this.list = list;
        }

        if (this.pageNum === 2) {
          this.list = list;
        }

        if (this.flag == 1) {
          this.list = list;
        }

        if (this.list.length < resData.total) {
          this.finished = false;
          this.finishedText = ""
        } else {
          this.finished = true;
          this.finishedText = "暂无更多数据"
        }

        if (this.list.length == 0) {
          this.finished = true;
          this.finishedText = ""
        }
        this.listCallback(resData);

      }).catch(e => {
        this.finished = true;
        this.finishedText = ""
      });
    },
  },
}

export const pageRes = {
  data() {
    return {
      requestType: 'PUT',
      pageNum: 1,
      pageSize: 20,
      list: [],
      listUrl: "",
      listCount: 0,
      listLoading: false,
      finished: false, //是否加载完成
      finishedText: "暂无更多数据",
      timer: {},
      orderType: null
    }
  },
  methods: {
    setRequestType(type) {
      this.requestType = type;
    },
    initListAjax(url, orderType) {
      this.orderType = orderType;
      this.listUrl = url;
      setTimeout(_ => {
        this.getListHttp();
      }, 500)
    },
    // 搜索
    searchAjax(url) {
      console.log(11111)
      if (url) {
        this.listUrl = url;
      }
      // this.finishedText = "";
      this.finished = false;
      this.listLoading = true;
      this.pageNum = 1;
      this.list = [];
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.getListHttp();
      }, 500)
    },
    // 设置自定义参数
    setListParams(params) { },
    //请求回调
    listCallback() { },
    nextPage() {
      if (this.listUrl) {
        // this.pageNum++;
        this.getListHttp();
      }
    },
    // ajax请求
    getListHttp() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderType: localStorage.getItem("orderType")
      }
      this.setListParams(params);
      if (params.pageNum == 1) {
        this.list = [];
      }
      this.listLoading = true;
      this.$http({
        type: this.requestType,
        url: this.listUrl,
        data: params
      }).then(resData => {
        if (this.customCallback) {
          this.customCallback(resData, params)
          return
        }
        this.allAjaxData = resData
        this.listLoading = false;
        this.listCount = resData.data.data.total;
        const list = resData.data.data.records;
        if (params.pageNum > 1) {
          this.list = this.list.concat(list);
        } else {
          this.list = list;
        }
        if (this.list.length < resData.data.data.total) {
          this.finished = false;
          this.finishedText = ""
        } else {
          this.finished = true;
          this.finishedText = "暂无更多数据"
        }
        if (this.list.length == 0) {
          this.finished = true;
          this.finishedText = ""
        }
        this.listCallback(resData.data.data);
      });
    }
  }
}
// 验证码倒计时
const CODE_SIZE = 60;
export const codeTools = {
  data() {
    return {
      CODE_SIZE,
      codeIndex: CODE_SIZE,
      timer: {},
    }
  },
  destroyed() {
    window.clearInterval(this.timer);
  },
  methods: {
    timerStart() {
      if (this.codeIndex != CODE_SIZE) {
        return;
      }
      window.clearInterval(this.timer);
      this.codeIndex--;
      this.timer = window.setInterval(() => {
        this.codeIndex--;
        console.log(this.codeIndex)
        if (this.codeIndex <= 0) {
          window.clearInterval(this.timer);
          this.codeIndex = CODE_SIZE;
          return
        }
      }, 1000)
    },
    getCodeAjax(mobile) {
      if (!this.$regulars.isPhone(mobile)) {
        this.$notice.msg("请输入正确的手机号")
        return;
      }
      this.timerStart();
      this.$http({
        type: "GET",
        url: "/api/user/sendCode",
        data: {
          mobile
        }
      }).then(res => {

      }).catch(e => {
        window.clearInterval(this.timer);
        this.codeIndex = CODE_SIZE;
      })
    }
  }
}
